export default __webpack_public_path__ + "static/media/queenofpeace.9bc4e91a.jpg";